let repeat = (str, n = 0) => Array(Math.max(0, n) + 1).join(str)

export default repeat


/** WEBPACK FOOTER **
 ** ./src/scripts/lib/repeat.js
 **/